// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1VVPq","item":"PaymentsMobile_item__6tPhB","label":"PaymentsMobile_label__2u2pk","amount":"PaymentsMobile_amount__1fFbE"};